export default __webpack_public_path__ + "static/media/preview-editor.d3965170.jpg";